import { http } from '@/http-common'

import * as Response from '@/types/network/response'

import { NodeDataList as State, NodeData, NodeInfo, CalcDataField } from '@/types/state'
import { Default as Commit } from '@/types/mutations'
import { AxiosResponse } from 'axios'

function formatDate(date: Date): string {
  const dateString = date.toISOString()
  return dateString.substring(8, 10) + "/" + dateString.substring(5, 7) + "/" + dateString.substring(0, 4)
}

export default {
    namespaced: true,
    state: {
        calcDataFields: [],
        nodeDatas: [],
        dataStartDate: null,
        dataEndDate: null,
        preloaded: false
    },
    mutations: {
        SET_CALC_DATA_FIELDS(state: State, calcDataFields: Array<CalcDataField>): void {
            state.calcDataFields = calcDataFields
        },
        SET_NODE_DATAS(state: State, nodeDatas: Array<NodeData>): void {
            state.nodeDatas = nodeDatas
            state.preloaded = true
        },
        UPDATE_NODE_ALIAS(state: State, node: NodeInfo): void {
            const nodeInList = state.nodeDatas.findIndex(n => n.nodeId == node.id)
            if (nodeInList >= 0) {
                state.nodeDatas[nodeInList].alias = node.alias
            }
        },
        SET_PRELOADED(state: State, preloaded: boolean): void {
            state.preloaded = preloaded
        },
        SET_DATE_RANGE(state: State, dates: { start: Date, end: Date }): void {
            state.dataStartDate = dates.start
            state.dataEndDate = dates.end
        },
        SET_END_DATE(state: State, endDate: Date): void {
            state.dataEndDate = endDate
        }
    },
    actions: {
        async init({ commit, state } : Commit): Promise<Response.AuthenticationFailed | boolean> {
            commit('SET_START_DATE', new Date(Date.now() - 1000*60*60*24*7))
            commit('SET_END_DATE', new Date(Date.now()))

            return await http.get('/calculated-data-fields')
                .then(async (calcDataFields: any) => {
                    commit('SET_CALC_DATA_FIELDS', calcDataFields)
                    const startDate = formatDate(state.dataStartDate)
                    const endDate = formatDate(state.dataEndDate)
                    return await http.get(`/user-node-datas?startDate=${startDate}&endDate=${endDate}`)
                        // eslint-disable-next-line
                        .then((response: any) => {
                            const nodeDatas = response.data
                            
                            commit('SET_NODE_DATAS', nodeDatas)
                            return true
                        })
                        .catch((error : Response.AuthenticationError) => {
                            return error.response
                        })
                })
                .catch((error : any) => {
                    return error
                })
        },
        async getNodeDatasInDateRange({ state } : Commit): Promise<AxiosResponse<any>> {
            const startDate = formatDate(state.dataStartDate)
            const endDate = formatDate(state.dataEndDate)
            return http.get(`/user-node-datas?startDate=${startDate}&endDate=${endDate}`)
                .then((response: any) => response.data)
                .catch(() => [])
        }
    },
    getters: {
        CalcDataFields: (state: State) : Array<CalcDataField> => state.calcDataFields,
        NodeDatas: (state: State) : Array<NodeData> => state.nodeDatas,
        IsPreloaded: (state: State) : boolean => state.preloaded
    }
}

